import { CdkScrollable } from '@angular/cdk/scrolling';
import { AfterViewInit, Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { InfoDialogConfig } from '@service/dialog.service';

@Component({
  selector: 'info-dialog',
  styleUrls: ['./info-dialog.component.scss'],
  templateUrl: './info-dialog.component.html',
  imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, MatButton],
})
export class InfoDialogComponent implements AfterViewInit {
  dialogRef = inject<MatDialogRef<InfoDialogComponent>>(MatDialogRef);
  data = inject<InfoDialogConfig>(MAT_DIALOG_DATA);

  /**
   * Lifecycle hook that is called after Angular has fully initialized a component's view.
   * If a `timeout` value is provided in the `data` object, this method sets a timer to automatically close the dialog after the specified duration.
   */
  ngAfterViewInit() {
    if (this.data.timeout) {
      setTimeout(() => {
        this.dialogRef.close();
      }, this.data.timeout);
    }
  }

  /**
   * Handles the click event for Button 1.
   * Closes the dialog and returns the string 'button1' as the result.
   */
  onButton1Click(): void {
    this.dialogRef.close('button1');
  }

  /**
   * Handles the click event for the second button in the dialog.
   * Closes the dialog and returns the string 'button2' as the result.
   */
  onButton2Click(): void {
    this.dialogRef.close('button2');
  }
}
